import net from '../../utils/net'
export default {
  // 查询基础配置信息
  GetBasicConfigurationInfo (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  SaveBasicConfiguration (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取公司巡店配置
  GetShopTourConfig (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 修改巡店模块配置
  SaveShopTourConfig (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺字段配置
  GetStoreFieldConfig (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 修改公司店铺字段配置
  SaveStoreFieldConfig (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取公司基础信息
  GetBasicInfo (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 修改公司基础信息
  SaveBasicInfo (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 报修模块配置详情
  GetMntsetting (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 报修模块配置修改
  SaveMntsettingchange (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 道具模块详情配置
  GetPropsetting (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 修改公司基础信息
  SavePropsettingchange (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取邮件配置
  GetMailsetting (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 修改邮件配置
  SaveMailsettingChange (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
